import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { ChartConfiguration, ChartData, ChartEvent, ChartType } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import * as moment from 'moment';
import { AnalyticsTask } from 'src/app/models/AnalyticsTask';

@Component({
  selector: 'app-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.css']
})
export class LineChartComponent implements OnInit, OnChanges {
  @Input() dateTo: string;
  @Input() cooperationsData: AnalyticsTask[];
  @Input() dateFrom: string;
  @Input() cooperationNames: string[];

  public loaded = false;
  public lineChartType: ChartType = 'line';
  public lineChartData: ChartData = {
    datasets: [
      {
        data: [],
        label: 'Število opravil na dan',
        borderColor: 'orange',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointBackgroundColor: 'black',
        tension: 0.4,
        borderWidth: 3, 
      }
    ],
    labels: [],
  };

  public lineChartOptions: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        beginAtZero: true,
      },
      y: {
        beginAtZero: true,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
    elements: {
      line: {
        fill: true, // Enable fill color under the line
      }
    },
    backgroundColor: 'rgba(255, 165, 0, 0.3)', // Specify the fill color

  };

  public lineChartPlugins = [];

  constructor() { }

  ngOnInit(): void {
    this.adjustToScreenSize();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['cooperationsData'] || changes['dateFrom'] || changes['dateTo']) {
      this.prepareChartData();
    }
  }

  adjustToScreenSize(): void {
    this.loaded = window.screen.width < 500; // Example condition for mobile devices
  }

  prepareChartData(): void {
    if (!this.cooperationsData) {
      console.warn('cooperationsData is undefined or null');
      return; // Exit the method if cooperationsData is not defined
    }

    let startDate = moment(this.dateFrom, "DD.MM.YYYY");
    let endDate = moment(this.dateTo, "DD.MM.YYYY");
    let diffDays = endDate.diff(startDate, 'days');

    let labels: string[] = [];
    let data: number[] = [];

    for (let i = 0; i <= diffDays; i++) {
      let currentDate = startDate.clone().add(i, 'days').format("DD.MM.YYYY");
      labels.push(currentDate);

      let count = this.cooperationsData.filter((task) => task.date === currentDate).length;
      data.push(count);
    }

    this.lineChartData.labels = labels;
    this.lineChartData.datasets[0].data = data;
    this.loaded = true;
  }

}
